import { CSInterface } from "csinterface-ts";
import { getFontStyle, getFontWeight } from "../../store/utils/fontFaceFileGenerator";
import { jsxConstsEvents, jsxConstFunctions } from "../jsxConsts";
const { csInterface }: { csInterface: CSInterface } = window as any;

export function renderFontsListener() {
  csInterface.addEventListener(jsxConstsEvents.renderFonts, (data: any) => {
    const fontFormData = {
      origin: 0,
      fPath: "",
      fClass: "",
      fFamily: "",
      fWeight: "",
      fStyle: "",
      fName: "",
      fStyleAndWeight: "",
    };
    const fonts = [];
    const len = data.data.fonts.length;
    for (let i = 0; i < len; i += 1) {
      const { family, style, name } = data.data.fonts[i];
      const weight = getFontWeight(style, name, family, true);
      const processedStyle = getFontStyle(style, name, family, true);
      const font = {
        ...fontFormData,
        fFamily: family,
        fName: name,
        fStyleAndWeight: style,
        fWeight: weight,
        fStyle: processedStyle,
      };
      fonts.push(font);
    }
    const fontsInfoString = JSON.stringify({ list: fonts });
    const eScript = jsxConstFunctions.setFontData.replace(
      "%VALUE%",
      fontsInfoString
    );
    csInterface.evalScript(eScript, (res) => {console.log('')});
  });
}
